const PAYMENT_DIRECTION = {
    PAY_IN: 0,
    PAY_OUT: 1,
}

export { PAYMENT_DIRECTION }
export default PAYMENT_DIRECTION



// WEBPACK FOOTER //
// ./src/enums/paymentDirection.js